var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useGetMyBreakoutRoomsQuery, useJoinRoomMutation, } from '../../../store/services/breakoutRoomApi';
import { store } from '../../../store';
import Duration from '../list/room/duration';
import { JoinBreakoutRoomReq } from '../../../helpers/proto/plugnmeet_breakout_room_pb';
const MyBreakoutRooms = () => {
    var _a, _b;
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const { data: myRooms, isLoading: isLoadingMyRooms } = useGetMyBreakoutRoomsQuery(undefined, {
        pollingInterval: 10000,
    });
    const [joinRoom, { isLoading, data }] = useJoinRoomMutation();
    const [token, setToken] = useState('');
    const userId = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : '';
    useEffect(() => {
        var _a;
        if (!isLoading && data) {
            if (!data.status) {
                toast(t(data.msg), {
                    type: 'error',
                });
                return;
            }
            setToken((_a = data.token) !== null && _a !== void 0 ? _a : '');
        }
    }, [isLoading, data]);
    useEffect(() => {
        if (token !== '') {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('access_token', token);
            const url = location.protocol +
                '//' +
                location.host +
                window.location.pathname +
                '?' +
                searchParams.toString();
            window.open(url, '_blank');
        }
    }, [token]);
    const join = () => {
        var _a, _b, _c, _d;
        joinRoom(new JoinBreakoutRoomReq({
            breakoutRoomId: (_b = (_a = myRooms === null || myRooms === void 0 ? void 0 : myRooms.room) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
            userId: (_d = (_c = store.getState().session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
        }));
    };
    const render = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!myRooms) {
            return null;
        }
        return (_jsxs("div", { className: "poll-item relative overflow-hidden border border-solid border-primaryColor/70 dark:border-darkText/70 px-2 py-8 rounded-lg mb-4 transition ease-in hover:shadow-md", children: [_jsx("div", { className: "poll-title text-md text-primaryColor dark:text-darkText", children: (_a = myRooms.room) === null || _a === void 0 ? void 0 : _a.title }), _jsxs("div", { className: "total-vote rounded-bl-lg bg-secondaryColor absolute top-0 right-0 text-white text-[10px] py-1 px-3 uppercase", children: [_jsxs("strong", { children: [t('polls.total'), ": "] }), " ", (_b = myRooms.room) === null || _b === void 0 ? void 0 : _b.users.length] }), ((_c = myRooms.room) === null || _c === void 0 ? void 0 : _c.started) ? (_jsx("div", { className: "status absolute top-0 left-0 text-[10px] text-white", children: _jsx(Duration, { duration: (_e = (_d = myRooms.room) === null || _d === void 0 ? void 0 : _d.duration) !== null && _e !== void 0 ? _e : 5, created: (_g = (_f = myRooms.room) === null || _f === void 0 ? void 0 : _f.created) !== null && _g !== void 0 ? _g : Date.now() }) })) : (_jsx("div", { className: "status absolute top-0 left-0 bg-secondaryColor text-[10px] text-white py-1 px-3 uppercase rounded-br-lg", children: t('breakout-room.not-started') })), _jsxs("div", { className: "btn", children: [_jsx("p", { className: "absolute left-2 bottom-2 text-xs dark:text-secondaryColor", children: ((_h = myRooms.room) === null || _h === void 0 ? void 0 : _h.users.filter((u) => u.joined === true && u.id === userId).length)
                                ? t('breakout-room.user-joined')
                                : t('breakout-room.not-joined') }), _jsx("button", { onClick: join, className: "absolute right-0 bottom-0 transition ease-in bg-primaryColor hover:bg-secondaryColor text-[10px] text-white pt-1 pb-[2px] px-3 uppercase rounded-tl-lg", disabled: !!isLoading, children: t('breakout-room.join') })] })] }));
    };
    return (_jsx("div", { className: `polls-list-wrapper relative overflow-auto scrollBar px-2 pt-2 xl:pt-3 h-full`, children: _jsxs("div", { className: "polls-list-wrap-inner", children: [render(), isLoadingMyRooms ? (_jsx("div", { className: "loading absolute text-center top-1/2 -translate-y-1/2 z-[999] left-0 right-0 m-auto", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null] }) }));
};
_react_refresh_temp_1 = MyBreakoutRooms;
$RefreshReg$(_react_refresh_temp_1, "MyBreakoutRooms");
_react_refresh_temp_2(MyBreakoutRooms, "BRB9PpvxuEb8pIPYyDiRTtJyR/o=", false, () => [useTranslation, useGetMyBreakoutRoomsQuery, useJoinRoomMutation]);
export default MyBreakoutRooms;
